import { useMemo } from 'react';
import { useUsersOptions as useUsersOptionsHook } from '@/pages/Inventory/pages/Assets/hooks';
import { Option } from '@/components/inputs/AutocompleteInput';

interface UseUsersOptionsProps {
  search?: string;
  minLength?: number;
  phone?: string;
  status?: string;
}

const useUsersOptions = ({ search, minLength = 3, phone, status }: UseUsersOptionsProps = {}) => {
  const { users, isUsersLoading } = useUsersOptionsHook({
    search: search && search.length >= minLength ? search : undefined,
    phone,
    status,
  });

  const userOptions: Option[] = useMemo(() => 
    users.map((user) => ({
      label: user.fullName,
      data: user,
    })), [users]
  );

  return {
    users,
    userOptions,
    isUsersLoading,
  };
};

export default useUsersOptions; 